import { render, staticRenderFns } from "./RegisterSongDetails.vue?vue&type=template&id=b58899d2&scoped=true"
import script from "./RegisterSongDetails.vue?vue&type=script&lang=ts"
export * from "./RegisterSongDetails.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongDetails.vue?vue&type=style&index=0&id=b58899d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58899d2",
  null
  
)

export default component.exports